import axios from "axios"
import jwt from "jwt-decode"
import {
    USER_LOGIN_FAIL,
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_RESET,
    USER_LOGOUT,
    USER_REGISTER_FAIL,
    USER_REGISTER_REQUEST,
    USER_REGISTER_SUCCESS,
    USER_CONFIRM_REGISTER_REQUEST,
    USER_CONFIRM_REGISTER_SUCCESS,
    USER_CONFIRM_REGISTER_FAIL,
    USER_CREATE_PASSWORD_REQUEST,
    USER_CREATE_PASSWORD_SUCCESS,
    USER_CREATE_PASSWORD_FAIL,
    USER_RECOVERY_REQUEST,
    USER_RECOVERY_SUCCESS,
    USER_RECOVERY_FAIL,
    USER_DETAILS_RESET,
    USER_LIST_RESET,
    USER_PROFILE_INFORMATION_REQUEST,
    USER_PROFILE_INFORMATION_REQUEST_SUCCESS,
    USER_PROFILE_INFORMATION_REQUEST_FAIL,
    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_REQUEST_SUCCESS,
    USER_UPDATE_PROFILE_REQUEST_FAIL,
    USER_UPDATE_IMAGE_REQUEST,
    USER_UPDATE_IMAGE_SUCCESS,
    USER_UPDATE_IMAGE_FAIL,
    USER_ADD_BOOKMARCK_REQUEST,
    USER_ADD_BOOKMARCK_REQUEST_SUCCESS,
    USER_ADD_BOOKMARCK_REQUEST_FAIL,
    USER_REMOVE_BOOKMARCK_REQUEST,
    USER_REMOVE_BOOKMARCK_REQUEST_SUCCESS,
    USER_REMOVE_BOOKMARCK_REQUEST_FAIL,
    USER_UPDATE_PASSWORD_REQUEST,
    USER_UPDATE_PASSWORD_REQUEST_SUCCESS,
    USER_UPDATE_PASSWORD_REQUEST_FAIL,
    USER_LIST_OF_PAID_INVOICES_REQUEST,
    USER_LIST_OF_PAID_INVOICES_REQUEST_SUCCESS,
    USER_LIST_OF_PAID_INVOICES_REQUEST_FAIL,
    USER_LIST_OF_UNPAID_INVOICES_REQUEST,
    USER_LIST_OF_UNPAID_INVOICES_REQUEST_SUCCESS,
    USER_LIST_OF_UNPAID_INVOICES_REQUEST_FAIL,
} from "./userConstants"

const userTokenLocal = localStorage.getItem("token")

//Invoice

export const listOfPaidInvoices = (pageNumber = 1) => async (
    dispatch
) => {

    try {

        dispatch({
            type: USER_LIST_OF_PAID_INVOICES_REQUEST,
        })

        if (typeof userTokenLocal !== 'undefined') {
            if (userTokenLocal !== "" && userTokenLocal !== null) {

                const config = {
                    headers: {
                        Authorization: `Bearer ` + userTokenLocal,
                    },
                };

                const { data } = await axios.get('/api/invoices/list/?page=' + pageNumber + '&IsPaid=true', config)


                if (data.status === "ok") {

                    dispatch({
                        type: USER_LIST_OF_PAID_INVOICES_REQUEST_SUCCESS,
                        payload: data.data
                    })

                }
                else {

                    dispatch({
                        type: USER_LIST_OF_PAID_INVOICES_REQUEST_FAIL,
                        payload: 'خطا در دریافت اطلاعات از سرور'
                    })

                }

            }
            else {

                dispatch({
                    type: USER_LIST_OF_PAID_INVOICES_REQUEST_FAIL,
                    payload: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.'
                })

            }
        }
        else {

            dispatch({
                type: USER_LIST_OF_PAID_INVOICES_REQUEST_FAIL,
                payload: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.'
            })

        }

    } catch (error) {

        dispatch({
            type: USER_LIST_OF_PAID_INVOICES_REQUEST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });

    }

}

export const listOfunpaidInvoices = (pageNumber = 1) => async (
    dispatch
) => {

    try {

        dispatch({
            type: USER_LIST_OF_UNPAID_INVOICES_REQUEST,
        })

        if (typeof userTokenLocal !== 'undefined') {
            if (userTokenLocal !== "" && userTokenLocal !== null) {

                const config = {
                    headers: {
                        Authorization: `Bearer ` + userTokenLocal,
                    },
                };

                const { data } = await axios.get('/api/invoices/list/?page=' + pageNumber + '&IsPaid=false', config)

                if (data.status === "ok") {
                    dispatch({
                        type: USER_LIST_OF_UNPAID_INVOICES_REQUEST_SUCCESS,
                        payload: data.data
                    })

                }
                else {

                    dispatch({
                        type: USER_LIST_OF_UNPAID_INVOICES_REQUEST_FAIL,
                        payload: 'خطا در دریافت اطلاعات از سرور'
                    })

                }

            }
            else {

                dispatch({
                    type: USER_LIST_OF_UNPAID_INVOICES_REQUEST_FAIL,
                    payload: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.'
                })

            }
        }
        else {

            dispatch({
                type: USER_LIST_OF_UNPAID_INVOICES_REQUEST_FAIL,
                payload: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.'
            })

        }

    } catch (error) {

        dispatch({
            type: USER_LIST_OF_UNPAID_INVOICES_REQUEST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });

    }

}

//Bookmarks

export const addBookmark = (pid) => async (dispatch) => {
    try {

        dispatch({
            type: USER_ADD_BOOKMARCK_REQUEST,
        })

        if (typeof userTokenLocal !== 'undefined') {

            if (userTokenLocal !== "" && userTokenLocal !== null) {

                var formData = new FormData()
                formData.append('ProductId', pid)

                await axios.post("/api/products/bookmarks/add", formData, {

                    headers: {
                        Authorization: `Bearer ` + userTokenLocal,
                        'content-type': 'multipart/form-data'
                    }

                }).then(function (response) {

                    if (response.data.status === "ok") {

                        dispatch({
                            type: USER_ADD_BOOKMARCK_REQUEST_SUCCESS,
                            payload: { status: true, message: 'این محصول با موفقیت به لیست نشان شده های شما اضافه شد.' }
                        })

                    }
                    else {

                        dispatch({
                            type: USER_ADD_BOOKMARCK_REQUEST_FAIL,
                            payload: { status: false, message: 'خطا در ارسال اطلاعات' }
                        })

                    }

                }).catch(function (error) {

                    dispatch({
                        type: USER_ADD_BOOKMARCK_REQUEST_FAIL,
                        payload: { status: false, message: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.' }
                    })

                });

            }
            else {

                dispatch({
                    type: USER_ADD_BOOKMARCK_REQUEST_FAIL,
                    payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
                })

            }
        }
        else {

            dispatch({
                type: USER_ADD_BOOKMARCK_REQUEST_FAIL,
                payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
            })

        }

    } catch (error) {
        dispatch({
            type: USER_ADD_BOOKMARCK_REQUEST_FAIL,
            payload:
            {
                status: false, message: error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
            }
        });
    }
};

export const deleteBookmark = (bid) => async (dispatch) => {
    try {

        dispatch({
            type: USER_REMOVE_BOOKMARCK_REQUEST,
        })

        if (typeof userTokenLocal !== 'undefined') {

            if (userTokenLocal !== "" && userTokenLocal !== null) {

                var formData = new FormData()
                formData.append('ProductId', bid)

                await axios.post("/api/products/bookmarks/remove", formData, {

                    headers: {
                        Authorization: `Bearer ` + userTokenLocal,
                        'content-type': 'multipart/form-data'
                    }

                }).then(function (response) {

                    if (response.data.status === "ok") {

                        dispatch({
                            type: USER_REMOVE_BOOKMARCK_REQUEST_SUCCESS,
                            payload: { status: true, message: 'محصول با موفقیت از لیست نشان شده های شما حذف شد.' }
                        })

                    }
                    else {

                        dispatch({
                            type: USER_REMOVE_BOOKMARCK_REQUEST_FAIL,
                            payload: { status: false, message: 'خطا در ارسال اطلاعات' }
                        })

                    }

                }).catch(function (error) {

                    dispatch({
                        type: USER_REMOVE_BOOKMARCK_REQUEST_FAIL,
                        payload: { status: false, message: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.' }
                    })

                });

            }
            else {

                dispatch({
                    type: USER_REMOVE_BOOKMARCK_REQUEST_FAIL,
                    payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
                })

            }
        }
        else {

            dispatch({
                type: USER_REMOVE_BOOKMARCK_REQUEST_FAIL,
                payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
            })

        }

    } catch (error) {
        dispatch({
            type: USER_REMOVE_BOOKMARCK_REQUEST_FAIL,
            payload: {
                status: false, message: error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
            }
        });
    }
};

//Users

export const prfileInformation = () => async (dispatch) => {
    try {

        dispatch({
            type: USER_PROFILE_INFORMATION_REQUEST,
        })

        if (typeof userTokenLocal !== 'undefined') {
            if (userTokenLocal !== "" && userTokenLocal !== null) {

                const config = {
                    headers: {
                        Authorization: `Bearer ` + userTokenLocal,
                    },
                };

                await axios.get('/api/accounts/profile', config).then(response => {

                    if (response.data.status === "ok") {

                        dispatch({
                            type: USER_PROFILE_INFORMATION_REQUEST_SUCCESS,
                            payload: response.data.data
                        })

                    }
                    else {

                        dispatch({
                            type: USER_PROFILE_INFORMATION_REQUEST_FAIL,
                            payload: 'خطا در دریافت اطلاعات از سرور'
                        })

                    }

                }).catch(function (error) {

                    dispatch({
                        type: USER_PROFILE_INFORMATION_REQUEST_FAIL,
                        payload: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.'
                    })

                });

            }
            else {

                dispatch({
                    type: USER_PROFILE_INFORMATION_REQUEST_FAIL,
                    payload: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.'
                })

            }
        }
        else {

            dispatch({
                type: USER_PROFILE_INFORMATION_REQUEST_FAIL,
                payload: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.'
            })

        }

    } catch (error) {

        dispatch({
            type: USER_PROFILE_INFORMATION_REQUEST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });

    }
};

export const prfileUpdate = (formData) => async (dispatch) => {
    try {

        dispatch({
            type: USER_UPDATE_PROFILE_REQUEST,
        })

        if (typeof userTokenLocal !== 'undefined') {

            if (userTokenLocal !== "" && userTokenLocal !== null) {

                await axios.post("/api/accounts/profile/updatetexts", formData, {

                    headers: {
                        Authorization: `Bearer ` + userTokenLocal,
                        'content-type': 'multipart/form-data'
                    }

                }).then(function (response) {

                    if (response.data.status === "ok") {

                        dispatch({
                            type: USER_UPDATE_PROFILE_REQUEST_SUCCESS,
                            payload: { status: true, message: 'اطلاعات کاربری شما با موفقیت بروز شد.' }
                        })

                    }
                    else {

                        dispatch({
                            type: USER_UPDATE_PROFILE_REQUEST_FAIL,
                            payload: { status: false, message: 'خطا در ارسال اطلاعات' }
                        })

                    }

                }).catch(function (error) {

                    dispatch({
                        type: USER_UPDATE_PROFILE_REQUEST_FAIL,
                        payload: { status: false, message: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.' }
                    })

                });

            }
            else {

                dispatch({
                    type: USER_UPDATE_PROFILE_REQUEST_FAIL,
                    payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
                })

            }
        }
        else {

            dispatch({
                type: USER_UPDATE_PROFILE_REQUEST_FAIL,
                payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
            })

        }

    } catch (error) {
        dispatch({
            type: USER_UPDATE_PROFILE_REQUEST_FAIL,
            payload:
            {
                status: false, message: error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
            }
        });
    }
};

export const passwordUpdate = (formData) => async (dispatch) => {
    try {

        dispatch({
            type: USER_UPDATE_PASSWORD_REQUEST,
        })

        if (typeof userTokenLocal !== 'undefined') {

            if (userTokenLocal !== "" && userTokenLocal !== null) {

                await axios.post("/api/accounts/profile/updatepassword", formData, {

                    headers: {
                        Authorization: `Bearer ` + userTokenLocal,
                        'content-type': 'multipart/form-data'
                    }

                }).then(function (response) {

                    if (response.data.status === "error" && response.data.message === "CurrentPasswordInvalid") {

                        dispatch({
                            type: USER_UPDATE_PASSWORD_REQUEST_SUCCESS,
                            payload: { status: false, message: 'رمز عبور فعلی صحیح نیست.' }
                        })

                    }
                    else if (response.data.status === "ok") {

                        dispatch({
                            type: USER_UPDATE_PASSWORD_REQUEST_SUCCESS,
                            payload: { status: true, message: 'رمز عبور شما با موفقیت تغییر کرد.' }
                        })

                    }
                    else {

                        dispatch({
                            type: USER_UPDATE_PASSWORD_REQUEST_FAIL,
                            payload: { status: false, message: 'خطا در ارسال اطلاعات' }
                        })

                    }

                }).catch(function (error) {

                    dispatch({
                        type: USER_UPDATE_PASSWORD_REQUEST_FAIL,
                        payload: { status: false, message: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.' }
                    })

                });

            }
            else {

                dispatch({
                    type: USER_UPDATE_PASSWORD_REQUEST_FAIL,
                    payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
                })

            }
        }
        else {

            dispatch({
                type: USER_UPDATE_PASSWORD_REQUEST_FAIL,
                payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
            })

        }

    } catch (error) {
        dispatch({
            type: USER_UPDATE_PASSWORD_REQUEST_FAIL,
            payload: {
                status: false, message:
                    error.response && error.response.data.message
                        ? error.response.data.message
                        : error.message
            }
        });
    }
};

export const imageUpdate = (formData) => async (dispatch) => {
    try {

        dispatch({
            type: USER_UPDATE_IMAGE_REQUEST,
        })

        if (typeof userTokenLocal !== 'undefined') {

            if (userTokenLocal !== "" && userTokenLocal !== null) {

                await axios.post("/api/accounts/profile/updateimg", formData, {

                    headers: {
                        Authorization: `Bearer ` + userTokenLocal,
                        'content-type': 'multipart/form-data'
                    }

                }).then(function (response) {

                    if (response.data.status === "ok") {

                        dispatch({
                            type: USER_UPDATE_IMAGE_SUCCESS,
                            payload: { status: true, message: 'تصویر کاربری با موفقیت بروز شد.' }
                        })

                    }
                    else {

                        dispatch({
                            type: USER_UPDATE_IMAGE_FAIL,
                            payload: { status: false, message: 'خطا در ارسال اطلاعات' }
                        })

                    }

                }).catch(function (error) {

                    dispatch({
                        type: USER_UPDATE_IMAGE_FAIL,
                        payload: { status: false, message: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.' }
                    })

                });

            }
            else {

                dispatch({
                    type: USER_UPDATE_IMAGE_FAIL,
                    payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
                })

            }
        }
        else {

            dispatch({
                type: USER_UPDATE_IMAGE_FAIL,
                payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
            })

        }

    } catch (error) {
        dispatch({
            type: USER_UPDATE_IMAGE_FAIL,
            payload: { status: false, message: error.response && error.response.data.message ? error.response.data.message : error.message, }
        });
    }
};

//Login Register

export const login = (body) => async (dispatch) => {
    try {
        dispatch({
            type: USER_LOGIN_REQUEST,
        });

        let config = {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
            },
        };

        const { data } = await axios.post("/api/accounts/Login", body, config);
        dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: data,
        });
        if (data.status === "ok") {
            let loginData = data
            if (jwt(data.token).Roles === "admin") {
                loginData.im = true
            }
            else {
                loginData.im = false
            }
            localStorage.setItem("userInfo", JSON.stringify(loginData));
        }
    } catch (error) {
        dispatch({
            type: USER_LOGIN_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const logout = () => (dispatch) => {


    let name = ".AspNetCore.Identity.Application"
    document.cookie = name + '.AspNetCore.Identity.Application=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    //localStorage.removeItem("cartItems");
    dispatch({ type: USER_LOGOUT });
    dispatch({ type: USER_LOGIN_RESET });
    dispatch({ type: USER_DETAILS_RESET });
    //dispatch({ type: ORDER_LIST_MY_RESET })
    dispatch({ type: USER_LIST_RESET });
    document.location.href = "/";
};

export const logoutNow = () => (dispatch) => {

    let name = ".AspNetCore.Identity.Application"
    document.cookie = name + '.AspNetCore.Identity.Application=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    //localStorage.removeItem("cartItems");
    dispatch({ type: USER_LOGOUT });
    dispatch({ type: USER_LOGIN_RESET });
    dispatch({ type: USER_DETAILS_RESET });
    //dispatch({ type: ORDER_LIST_MY_RESET })
    dispatch({ type: USER_LIST_RESET });
};

export const register = (body) => async (dispatch) => {
    try {
        dispatch({
            type: USER_REGISTER_REQUEST,
        });

        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await axios
            .post("/api/accounts/CreateUserByMobilePhone", body, config)
            .then((response) => {
                dispatch({
                    type: USER_REGISTER_SUCCESS,
                    payload: response.data,
                });
            });
    } catch (error) {
        dispatch({
            type: USER_REGISTER_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const confirmation = (body) => async (dispatch) => {
    try {
        dispatch({
            type: USER_CONFIRM_REGISTER_REQUEST,
        });

        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const { data } = await axios.post(
            "/api/accounts/CheckUserVerifyCode",
            body,
            config
        );

        dispatch({
            type: USER_CONFIRM_REGISTER_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: USER_CONFIRM_REGISTER_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const createPassword = (body, token) => async (dispatch) => {
    try {
        dispatch({
            type: USER_CREATE_PASSWORD_REQUEST,
        });

        const config = {
            headers: {
                Authorization: `Bearer ` + token,
                "Content-Type": "application/json",
            },
        };

        const { data } = await axios.post(
            "/api/accounts/CreatePassword",
            body,
            config
        );
        dispatch({
            type: USER_CREATE_PASSWORD_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: USER_CREATE_PASSWORD_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const recovery = (body) => async (dispatch) => {
    try {
        dispatch({
            type: USER_RECOVERY_REQUEST,
        });

        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const { data } = await axios.post(
            "/api/accounts/AccountRecovery",
            body,
            config
        );
        dispatch({
            type: USER_RECOVERY_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: USER_RECOVERY_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

